import { useContext } from "react";
import { AssetBlockContext } from "../CustomHooks/ContextApi";
import ACTIONS from "../../pages/DesignAssets/Design_Asset_Actions.json";
const GtDetails = () => {
    const {
        CBGTList,
        assetDetailsReset,
        UserScope,
        callSnackbar,
        CBGTListDispatch,
        selectedValuesHandler,
        gtCbConfigDataHandler,
        setIsOpenGtConfig,
        removeGt,
        gtConfigDataHandler,
      } = useContext(AssetBlockContext);
       const gtSelectHandler = (index) => {
        assetDetailsReset();
        if (UserScope.access.saveSLD) {
          const assetBlock = "gtDetailsBlock";
          const selectedAssetValue = "selectedGt";
          CBGTListDispatch({
                type: ACTIONS.GT_SELECT,
                payload: {
                index,
                },
            });
         setIsOpenGtConfig(true);
         selectedValuesHandler(index, selectedAssetValue, assetBlock);
         gtCbConfigDataHandler(index);
         gtConfigDataHandler(index);
         
        } else {
          callSnackbar(
            "error",
            `${UserScope.role} is not authorized to perform action on this page`
          );
        }
      };
        return (
    <>
    <div className={"col-md-12 mt-2"}>
        {CBGTList &&
          CBGTList?.map((gtData, index) => (
            <div
              className={
                (gtData?.uiData?.CBConfigured === false ? "unconfigured" : "") +
                " col-md-12  p-0"
              }
              key={index}
            >
             
              <div
                className="se-chip col-md-11 text-left d-flex justify-content-between"
              >
                <span>
                  <se-icon
                    size="small"
                    color="primary"
                    className="icon-small hydrated "
                  >
                    segment_building_small
                  </se-icon>
                  <span
                    data-testid="PvSubSelectionHandler"
                    style={{width:"150px"}}
                    className="align-top line-height-25 pointer d-inline-block displayPvChipName pl-1"
                    onClick={() => gtSelectHandler(index)}
                  >
                    {gtData?.configData.name}
                  </span>
                </span>

                <span className="pointer" onClick={() => removeGt(index)}>
                  <se-icon size="small" className="icon-small hydrated">
                    notification_error_plain
                  </se-icon>
                </span>
              </div>
            </div>
          ))}
      </div>
    </>
  )
}   
export default GtDetails